// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'onsenui/css/onsenui.css'
// import 'onsenui/css/onsen-css-components.css'
// import 'onsenui/css/dark-onsen-css-components.css'

// import './assets/css/commu-onsen-css-components.css'
// import './assets/css/dark-commu-onsen-css-components.css'

import Vue from 'vue'
import VueOnsen from 'vue-onsenui'
import store from './store'
import router from './router'
import App from './App'
// import firebase from 'firebase'
import firebase from 'firebase/app'
import 'firebase/firestore'
// import firebaseui from 'firebaseui'

// vue-event-calendarの定義
// import 'vue-event-calendar/dist/style.css'
// import vueEventCalendar from 'vue-event-calendar/dist/index.js'

Vue.config.productionTip = false

// Vue.use(vueEventCalendar, {locale: 'ja', weekStartOn: 1})

Vue.use(VueOnsen)

// firebaseの初期化
const config = {
  // ----- Prod -----

  // ----- Dev -----
  apiKey: 'AIzaSyAxI0jWlG54ew5D4TPTuxaohqbIT01-I9I',
  authDomain: 'miley-lasmeru.firebaseapp.com',
  databaseURL: 'https://miley-lasmeru.firebaseio.com',
  projectId: 'miley-lasmeru',
  storageBucket: 'miley-lasmeru.appspot.com',
  messagingSenderId: '573378209991',
  appId: '1:573378209991:web:03c8ded5a6d9c973e076e2',
  measurementId: 'G-VFZ6J1T7KF'
}

// firebase.initializeApp(config)
const firebaseApp = firebase.initializeApp(config)
const firestore = firebaseApp.firestore()
// firestore.settings({ timestampsInSnapshots: true })
export default firestore

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App },
  beforeCreate () {
    // Shortcut for Material Design
    // Vue.prototype.md = this.$ons.platform.isAndroid()
    Vue.prototype.md = false
    // Vue.prototype.md = true

    // Set iPhoneX flag based on URL
    if (window.location.search.match(/iphonex/i)) {
      document.documentElement.setAttribute('onsflag-iphonex-portrait', '')
      document.documentElement.setAttribute('onsflag-iphonex-landscape', '')
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js